import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { CultivationItemViewerComponent } from '../hierarchy-item/cultivation-item-viewer/cultivation-item-viewer.component';
import { GardenBedListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/garden-bed-list.response';
import { GardenBedType } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/garden-bed-type.enum';

/** Carte « planche » dans Mon Potager (maquette 01). */
@Component({
  selector: 'vw-bed-item',
  imports: [SharedModule, CommonModule, TranslateModule, CultivationItemViewerComponent],
  templateUrl: './bed-item.component.html',
  styleUrl: './bed-item.component.scss',
})
export class BedItemComponent {
  readonly GardenBedType = GardenBedType;

  @Input() bed!: GardenBedListResponse;
  /** Cultures « riches » (image + nom court) déjà résolues par le parent. */
  @Input() cultures: any[] = [];
  @Input() count = 0;
  @Input() freeCells = 0;

  get dimensionLabel(): string {
    if (this.bed.type === GardenBedType.POT) {
      return 'Pot';
    }
    return `${this.bed.rows ?? '-'} × ${this.bed.columns ?? '-'}`;
  }

  get previewCultures(): any[] {
    return this.cultures.slice(0, 4);
  }

  get extraCount(): number {
    return Math.max(0, this.count - 4);
  }
}
